import { useEffect } from 'react'
import { Offers, Coupons } from './pages'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { isDeviceRunningiOS } from './utils/validator'
import './App.css'
import { getParam } from './utils/params'

let isInit = false

window.addEventListener('message', function(event) {
  const messageEvent = event as MessageEvent
  console.log({
    'message-data': messageEvent.data
  })
  if (messageEvent.data['command'] === 'new-token-received') {
    localStorage.setItem('token', messageEvent.data['value'])
    const receivedAt = new Date()
    const requestedAt = new Date(parseInt(localStorage.getItem('requested-new-token-at') || '0'))
    const timeDiff = receivedAt.getTime() - requestedAt.getTime()
    console.log(`Time taken to receive new token: ${timeDiff} ms`)
  }
})

function App() {
  const token = getParam('token')
  console.log('REACT_APP_VERSION: ', process.env.REACT_APP_VERSION)
  localStorage.setItem('visit-id', new Date().getTime().toString())

  if (!isInit) {
    if (token) {
      localStorage.setItem('token', token)
    }
    isInit = true
  }

  useEffect(() => {
    // to add web history for enable triggering popstate for closing app when press back button
    if (!isDeviceRunningiOS()) {
      const enteredPathAndQuery = window.location.pathname + window.location.search
      window.history.pushState('detail', '', '/pre-app')
      window.history.pushState('detail', '', enteredPathAndQuery)
    }

    window.addEventListener('popstate', function(event) {
      window.parent.postMessage('popstate', '*')
    })

    console.log('App initialized')
  }, [])

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/offers" element={<Offers />} />
        <Route path="/offers/:offerId" element={<Offers />} />
        <Route path="/coupons" element={<Coupons />} />
        <Route path="/coupons/:couponId" element={<Coupons />} />
      </Routes>
    </BrowserRouter>
  )
}

export default App
